import { t as gsapWithCSS } from "@theme/gsap";
//#region frontend/islands/simple-dropdown-menu.js
var SimpleDropdownMenu = class extends HTMLElement {
	connectedCallback() {
		this.panel = this.querySelector("[data-dropdown-panel]");
		this.arrow = this.querySelector("svg");
		this.header = this.closest("header");
		gsapWithCSS.set(this.panel, { autoAlpha: 0 });
		this.addEventListener("mouseenter", () => this.show());
		this.onHeaderLeave = () => this.hide();
		this.header?.addEventListener("mouseleave", this.onHeaderLeave);
		this.querySelector("a[aria-expanded]")?.addEventListener("focus", () => this.show());
		this.onKeydown = (e) => {
			if (e.key === "Escape") {
				this.hide();
				this.querySelector("a[aria-expanded]")?.focus();
			}
		};
		this.onFocusOut = (e) => {
			if (!this.contains(e.relatedTarget)) this.hide();
		};
		this.addEventListener("focusout", this.onFocusOut);
	}
	show() {
		this.header?.querySelectorAll("mega-menu-dropdown").forEach((el) => {
			if (el !== this) el.hide?.();
		});
		this.querySelector("a[aria-expanded]")?.setAttribute("aria-expanded", "true");
		document.removeEventListener("keydown", this.onKeydown);
		document.addEventListener("keydown", this.onKeydown);
		gsapWithCSS.to(this.panel, {
			visibility: "visible",
			duration: .5,
			autoAlpha: 1,
			overwrite: true
		});
		gsapWithCSS.to(this.arrow, {
			rotate: -180,
			duration: .3
		});
	}
	hide() {
		this.querySelector("a[aria-expanded]")?.setAttribute("aria-expanded", "false");
		document.removeEventListener("keydown", this.onKeydown);
		gsapWithCSS.to(this.panel, {
			duration: .3,
			overwrite: true,
			autoAlpha: 0,
			onComplete: () => gsapWithCSS.set(this.panel, { visibility: "hidden" })
		});
		gsapWithCSS.to(this.arrow, {
			rotate: 0,
			duration: .5
		});
	}
	disconnectedCallback() {
		this.header?.removeEventListener("mouseleave", this.onHeaderLeave);
		document.removeEventListener("keydown", this.onKeydown);
		this.removeEventListener("focusout", this.onFocusOut);
	}
};
window.customElements.define("simple-dropdown-menu", SimpleDropdownMenu);
//#endregion
